import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Picker from "emoji-picker-react";

import {
    CircularProgress,
    LinearProgress, TextareaAutosize, TextField
} from "@mui/material";

import Divider from '@mui/joy/Divider';
import Chip from '@mui/joy/Chip';

import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

import styles from "./mobilechatroom.module.css";

import { useIonAlert, IonLoading, IonApp } from "@ionic/react";

import { ReactComponent as ArrowLeftLight } from "../../../src/svg/arrow-left-light.svg";
import { ReactComponent as SendTextUnactive } from "../../../src/svg/send_text_unactive.svg";
import { ReactComponent as SendText } from "../../../src/svg/paper-plane-top-solid.svg";
import { ReactComponent as Smile } from "../../../src/svg/smile.svg";
import { ReactComponent as Clip } from "../../../src/svg/clip.svg";
import { ReactComponent as Link } from "../../../src/svg/link.svg";

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

import { Camera, CameraResultType } from "@capacitor/camera";
import { Filesystem } from "@capacitor/filesystem";
import { IonAvatar } from "@ionic/react";

import { NativeSettings, AndroidSettings, IOSSettings } from "capacitor-native-settings";
import ImageViewer from "../etc/imageviewer/imageviewer";

import {
    IonButtons,
    IonButton,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
} from '@ionic/react';
import { CssVarsProvider, Textarea } from "@mui/joy";



var isTop = false;
var previousNode: any;

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "90%",
    bgcolor: 'white',
    outline: "none",
    borderRadius: "4px",
    boxShadow: "0 3px 25px -5px rgba(0,0,0,.35)"
};


const MobileChatRoomForFeedback: React.FC<any> = (props) => {

    const location: any = useLocation();
    const history = useHistory();
    const [platform, setPlatform] = useState("");

    const headerRef = useRef<any>(null);
    const footerRef = useRef<any>(null);
    const topperRef = useRef<any>(null);
    const [bodyHeight, setBodyHeight] = useState(0);

    const [data, setData] = useState<any>();
    const [message, setMessage] = useState("");

    const [update, setUpdate] = useState(0);

    const [isFocus, setIsFocus] = useState(false);

    const [rows, setRows] = useState(1);

    const [showPicker, setShowPicker] = useState(false);

    const [fileName, setFileName] = useState<any>("");
    const [file, setFile] = useState<any>();

    const [link, setLink] = useState("");

    const [imgLoading, setImgLoading] = useState(false);
    const [imgSrc, setImgSrc] = useState("");
    const [imgId, setImgId] = useState(0);

    const [open, setOpen] = React.useState(false);
    const [open2, setOpen2] = useState(false);

    const [index, setIndex] = useState(0);

    const [chatRoomId, setChatRoomId] = useState<any>();

    const chatRef = useRef<any>();
    const chatLastRef = useRef<any>();
    const voidRef = useRef<any>();

    const firstRef = useRef<any>(null);

    const textareaRef = useRef<any>(null);

    const [loading, setLoading] = useState(false);

    const [ionModalOpen, setIonModalOpen] = useState(false);
    const [ionModalSrc, setIonModalSrc] = useState("");

    const [presentAlert] = useIonAlert();

    const handleOpen = () => setOpen(true);
    const handleOpen2 = () => setOpen2(true);
    const handleClose = () => setOpen(false);
    const handleClose2 = () => { setOpen2(false); setLink(""); }

    useEffect(() => {

        const handleBackButton = () => {
            history.goBack();
        }

        document.addEventListener("backbutton", handleBackButton);

        return () => {
            document.removeEventListener("backbutton", handleBackButton);
        }

    }, []);

    const scrollTopCallback = useCallback((node: any) => {

        if (node !== null && !isTop && chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
            previousNode = node;
        }

        if (isTop) {
            isTop = false;
        }

    }, []);

    //플랫폼 정보 확인
    useEffect(() => {
        const platform = Capacitor.getPlatform();

        if (platform) {
            setPlatform(platform);
        }

    }, []);

    // chatRoomId는 location.state에서 직접 가져옴
    useEffect(() => {

        if (!location.state || !location.state.chatRoomId) {
            return;
        }

        setChatRoomId(location.state.chatRoomId);

    }, [props.user]);


    useEffect(() => {

        if (!headerRef || !footerRef || !headerRef.current || !footerRef.current || !topperRef || !topperRef.current) {
            return;
        }

        const caculateBodyHeight = () => {

            if (!headerRef || !footerRef || !headerRef.current || !footerRef.current || !topperRef || !topperRef.current) {
                return;
            }

            const value = 0;

            const topperPaddingTop = parseFloat(
                getComputedStyle(topperRef.current).paddingTop.replace("px", "")
            );

            const totalHeight = window.innerHeight;
            const safeareaTop = value;
            const headerHeight = headerRef.current.offsetHeight;
            const footerHeight = footerRef.current.offsetHeight;
            const footerBottom = parseFloat(
                getComputedStyle(footerRef.current).bottom.replace("px", "")
            );

            const lastHeight = totalHeight - value - headerHeight - footerHeight - topperPaddingTop - footerBottom;

            setBodyHeight(lastHeight);

            setTimeout(() => {

                if (!chatRef || !chatRef.current) {
                    return;
                }

                if (Capacitor.getPlatform() !== "android") {
                    return;
                }

                chatRef.current.scrollTop = chatRef.current.scrollHeight;

            }, 10);
        }

        caculateBodyHeight();

        window.addEventListener("resize", caculateBodyHeight);

        return () => window.removeEventListener("resize", caculateBodyHeight);

    }, [headerRef, footerRef, platform]);

    useEffect(() => {

        if (!chatRef || !chatRef.current) {
            return;
        }

        setTimeout(() => {

            if (!chatRef || !chatRef.current) {
                return;
            }

            chatRef.current.scrollTop = chatRef.current.scrollHeight;

        }, 50);

    }, [isFocus]);


    const onImageLoad = () => {
        if (chatRef && chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }


    useEffect(() => {
        getMessage();
    }, [chatRoomId, props.user, update, props.feedbackMessageUpdate]);


    const getMessage = async () => {

        setLoading(true);

        if (!props.user) {
            return;
        }

        if ((props.user) && !chatRoomId) {
            return;
        }

        var token: any = "";

        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });
            token = value;
        }

        fetch(`https://peetsunbae.com/dashboard/envelope/messagesforfeedback?index=${index}&chatRoomId=${chatRoomId}&kind=mobile`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Authorization": token
            }
        }).then((response: any) => {
            response.json()
                .then((result: any) => {

                    const data = result.data;
                    if (result.message !== "success") {
                        return;
                    }

                    if (result.message === "success" && result.data.length > 0) {
                        const newData = [];
                        const newDate = new Date(result.data[0].createdAt);
                        var newDateDay = "";
                        switch (newDate.getDay()) {
                            case 0: newDateDay = "일"; break;
                            case 1: newDateDay = "월"; break;
                            case 2: newDateDay = "화"; break;
                            case 3: newDateDay = "수"; break;
                            case 4: newDateDay = "목"; break;
                            case 5: newDateDay = "금"; break;
                            case 6: newDateDay = "토"; break;
                        }

                        const newDateString = `${newDate.getFullYear()}년 ${newDate.getMonth() + 1}월 ${newDate.getDate()}일 ${newDateDay}요일`;

                        const newDateRow = {
                            kind: "date", date: newDateString, id: Math.random()
                        }

                        newData.push(newDateRow);

                        var previousDate = newDateString;

                        result.data.forEach((eachData: any) => {

                            const newDate2 = new Date(eachData.createdAt);
                            var newDateDay2 = "";
                            switch (newDate2.getDay()) {
                                case 0: newDateDay2 = "일"; break;
                                case 1: newDateDay2 = "월"; break;
                                case 2: newDateDay2 = "화"; break;
                                case 3: newDateDay2 = "수"; break;
                                case 4: newDateDay2 = "목"; break;
                                case 5: newDateDay2 = "금"; break;
                                case 6: newDateDay2 = "토"; break;
                            }

                            const newDateString2 = `${newDate2.getFullYear()}년 ${newDate2.getMonth() + 1}월 ${newDate2.getDate()}일 ${newDateDay2}요일`;

                            const newDateRow2 = {
                                kind: "date", date: newDateString2, id: Math.random()
                            }

                            if (previousDate !== newDateString2) {
                                newData.push(newDateRow2);
                                previousDate = newDateString2;
                            }

                            newData.push(eachData);

                        })
                        setLoading(false);
                        setData(newData);
                        props.unreadMessage();

                    } else {
                        setData(result.data);
                        setLoading(false);
                    }
                })
        });

    }


    const handleChange = (e: any) => {
        setMessage(e.target.value);
    }

    const handleEmojiClick = (e: any, emojiObject: any) => {
        e.stopPropagation();
        setMessage((prevMessage: any) => prevMessage + emojiObject.emoji);
        setShowPicker(false);
    }

    const handleEmojiOpen = (e: any) => {
        e.stopPropagation();
        setShowPicker(!showPicker);
    }

    const mainClick = (e: any) => {
        setShowPicker(false);
    }


    const sendImage = async () => {

        if (props.user && (props.user.value === "student" || props.user.value === "parent")) {
            alert("이 방은 메세지 전송이 가능하지 않은 방입니다");
            return;
        }

        const permissionStatus = await Camera.checkPermissions();

        if (permissionStatus.camera === "denied" || permissionStatus.photos === "denied") {

            presentAlert({
                header: "접근 권한이 필요합니다",
                subHeader: "카메라, 사진첩 접근 권한이 필요합니다.",
                buttons: [
                    {
                        text: "Cancel",
                        role: "cancel",
                    },
                    {
                        text: "OK",
                        role: "confirm",
                        handler: () => {
                            NativeSettings.open({
                                optionAndroid: AndroidSettings.ApplicationDetails,
                                optionIOS: IOSSettings.App
                            })
                        }
                    }
                ]
            })

            return;
        }

        var image;

        try {
            image = await Camera.getPhoto({
                quality: 90,
                allowEditing: false,
                resultType: CameraResultType.Uri
            })
        } catch (e) {
            return;
        }

        if (!image) {
            return;
        }
        setImgLoading(true);

        var sendingFile: any;

        if (Capacitor.isNativePlatform()) {

            if (!image.path) {
                return;
            }

            const base64data: any = await Filesystem.readFile({
                path: image.path
            });

            const byteData = atob(base64data.data);
            const byteNumbers = new Array(byteData.length);

            for (var i = 0; i < byteData.length; i++) {
                byteNumbers[i] = byteData.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "image/jpeg" });
            const file = new File([blob], "chatImage.jpeg", { type: blob.type });
            sendingFile = file;

        } else {

            if (!image.webPath) {
                return;
            }

            const byteArray = await fetch(image.webPath);
            const blob = await byteArray.blob();
            const file = new File([blob], "chatImage.jpeg", { type: blob.type });
            sendingFile = file;
        }

        if (!sendingFile) {
            return;
        }

        var formData = new FormData();
        formData.append("chat_img", sendingFile);

        var token: any = "";

        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });
            token = value;
        }

        fetch("https://peetsunbae.com/dashboard/envelope/img", {
            method: "post",
            credentials: "include",
            headers: { "Authorization": token },
            body: formData
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    if (result.message === "success") {
                        handleSubmit("e", "img", result.src);
                    }
                    setImgLoading(false);
                })
        }).catch((error) => {
            setImgLoading(false);
            alert("업로드 실패");
        })

    }


    const handleSubmit = async (e: any, kind: string, mobileImgSrc: any = "") => {

        if (props.user && (props.user.value === "student" || props.user.value === "parent")) {
            alert("이 방은 메세지 전송이 가능하지 않은 방입니다");
            return;
        }

        if (textareaRef && textareaRef.current && Capacitor.getPlatform() === "ios") {
            textareaRef.current.blur();
        }

        var sendMessage = "";

        if (!props.user) {
            alert("잠시 후 시도하세요");
            return;
        }

        if (!chatRoomId) {
            alert("채팅룸을 선택하고 전송하세요");
            return;
        }

        if (kind === "text") {

            const newRow = {
                id: Math.random(),
                chatRoomId,
                direction: "teacher",
                fromUserId: props.user.id,
                kind: "text",
                message,
                name: "피드백 봇",
                readUser: [props.user.id],
                mine: true,
            }

            const newData = [...data];
            newData.push(newRow);
            setData([...newData]);
        }

        switch (kind) {
            case "text":
                sendMessage = message;
                setMessage("");
                break;
            case "img":
                sendMessage = mobileImgSrc;
                setImgSrc("");
                setOpen(false);
                break;
            case "link":
                sendMessage = link;
                setLink("");
                setOpen2(false);
                break;
            default:
                return;
        }

        if (!sendMessage) {
            return;
        }

        var token: any = "";

        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });
            token = value;
        }

        fetch("https://peetsunbae.com/dashboard/envelope/messagesforfeedback", {
            method: "post",
            headers: { "content-type": "application/json", "Authorization": token },
            credentials: "include",
            body: JSON.stringify({
                kind: kind,
                message: sendMessage,
                chatRoomId: chatRoomId
            })
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    if (result.message === "success") {
                        setUpdate(Math.random());
                        props.unreadMessage();
                        props.socket.emit("newFeedbackMessage", chatRoomId, props.user.id);
                    }
                })
        })
    }

    const letsShowImage = (url: string) => {
        setIonModalOpen(true);
        setIonModalSrc(url);
    }

    const ionModalClose = () => {
        setIonModalOpen(false);
        setIonModalSrc("");
    }

    const handleLinkClick = (url: string) => {
        try {
            const urlObj = new URL(url);
            const filloutMatch = urlObj.pathname.match(/\/t\/([^/?]+)/);
            if (filloutMatch) {
                const filloutId = filloutMatch[1];
                const feedbackMessageId = urlObj.searchParams.get("feedbackMessageId");
                const userId = urlObj.searchParams.get("userId");
                history.push({
                    pathname: "/mobiledashboard/filloutembed",
                    state: {
                        filloutId,
                        userId: userId ? +userId : props.user?.id,
                        feedbackMessageId: feedbackMessageId ? +feedbackMessageId : undefined,
                        returnUrl: "/mobiledashboard/envelope/feedbackroom",
                        chatRoomId,
                    }
                });
                return;
            }
        } catch (e) {}
        window.open(url, "_blank");
    };

    const renderMessageText = (text: string) => {
        return (
            <>
                {text.split("\n").map((line: string, i: number, arr: string[]) => (
                    <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
                ))}
            </>
        );
    };


    return (
        <IonApp>
            <div>
                <div className={styles.chatRoom} style={{
                    paddingTop: "var(--safe-area-inset-top)"
                }} onClick={mainClick}
                    ref={topperRef}
                >
                    <div className={styles.chatRoomHeader} ref={headerRef}>
                        <div>
                            <div className={`${styles.header} ${platform === "ios" ? styles.ios : ""}`} ref={props.headerRef}>
                                <div className={styles.backBtnDiv}
                                    onClick={() => { history.goBack(); }}
                                >
                                    <ArrowLeftLight
                                        className={styles.arrowLeft}
                                    />
                                </div>

                                <div className={styles.titleText}>
                                    소중한 피드백 부탁드려요
                                </div>

                            </div>
                        </div>
                    </div>


                    <div className={styles.chatRoomBody} ref={chatRef} style={{ height: `${bodyHeight}px`, overflow: "scroll" }}>
                        <div className={styles.chatBody}>

                            {
                                data &&
                                data.map((eachData: any, indexNumber: number) => {

                                    var timestring = "";

                                    if (eachData.createdAt) {
                                        const newDate = new Date(eachData.createdAt);
                                        timestring = `${newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours()}:${newDate.getMinutes() < 10 ? "0" + newDate.getMinutes() : newDate.getMinutes()}`
                                    }

                                    if (eachData.kind !== "date") {

                                        let isNotSubmitted = false;
                                        if (props.user && eachData.readUser) {
                                            let readUserArr = eachData.readUser;
                                            if (typeof readUserArr === "string") {
                                                try { readUserArr = JSON.parse(readUserArr); } catch (e) { readUserArr = []; }
                                            }
                                            isNotSubmitted = !readUserArr.includes(props.user.id);
                                        }

                                        return (
                                            <div key={eachData.id} className={styles.eachMessage} ref={(data.length - 1 === indexNumber && data.length !== 0) ? scrollTopCallback : (indexNumber === 5) ? firstRef : voidRef}>
                                                <>
                                                    <div className={styles.profileAnchor}>
                                                        <div className={`${styles.profileContainer} ${styles.ofStudent}`}>
                                                            <img src="img/message-bot.svg" alt="user" className={styles.avatar} />
                                                        </div>

                                                        <span className={styles.userName}>
                                                            피드백 봇
                                                        </span>
                                                    </div>
                                                    <div className={styles.msg_container}>
                                                        <div className={`${styles.msg_item} ${styles.ofStudent}`}>
                                                            <span className={styles.msg_text_box}>
                                                                {
                                                                    eachData.kind === "text" &&
                                                                    <span className={styles.msg_text_box}>
                                                                        <div>{renderMessageText(eachData.message)}</div>
                                                                    </span>
                                                                }
                                                                {
                                                                    eachData.kind === "img" &&
                                                                    <img onClick={(e: any) => { letsShowImage(`https://peetsunbae.com/${eachData.message.split("/public/")[1]}`); }} onLoad={onImageLoad} src={`https://peetsunbae.com/${eachData.message.split("/public/")[1]}`} className={styles.msg_img}>
                                                                    </img>
                                                                }
                                                                {
                                                                    eachData.kind === "link" &&
                                                                    <a href={eachData.message} target="_blank">
                                                                        {eachData.message}
                                                                    </a>
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className={styles.msg_extra}>
                                                            <div className={styles.msg_extra_action}>
                                                                <div className={styles.timeString}>
                                                                    {
                                                                        timestring
                                                                            ?
                                                                            timestring
                                                                            :
                                                                            <CircularProgress size="10px" />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        eachData.feedbackUrl &&
                                                        <div style={{ marginLeft: "8px", marginTop: "6px" }}>
                                                            <span
                                                                style={{
                                                                    display: "inline-block",
                                                                    padding: "8px 16px",
                                                                    backgroundColor: "#e8f5e9",
                                                                    color: "#2e7d32",
                                                                    borderRadius: "20px",
                                                                    fontSize: "13px",
                                                                    cursor: "pointer",
                                                                    fontFamily: "Apple_R",
                                                                    border: "none"
                                                                }}
                                                                onClick={() => handleLinkClick(eachData.feedbackUrl)}
                                                            >
                                                                📋 피드백 주기
                                                            </span>
                                                        </div>
                                                    }
                                                    {
                                                        isNotSubmitted &&
                                                        <div style={{ fontSize: "11px", color: "#e74c3c", marginLeft: "8px", marginTop: "4px", fontFamily: "Apple_R" }}>
                                                            * 설문 미제출
                                                        </div>
                                                    }
                                                </>

                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div key={eachData.id} className={`${styles.divider} ${(indexNumber === 0 && loading) ? styles.dividerNotShown : ""} `}>
                                                <CssVarsProvider>
                                                    <Divider>
                                                        <Chip variant="soft" color="neutral">
                                                            <span style={{ fontFamily: "Apple_R", fontSize: "11px" }}>{eachData.date}</span>
                                                        </Chip>
                                                    </Divider>
                                                </CssVarsProvider>
                                            </div>
                                        )
                                    }
                                })
                            }

                            <div style={{ height: isFocus ? 0 : "env(safe-area-inset-bottom)" }}>

                            </div>

                        </div>
                    </div>

                    <div ref={footerRef} className={styles.chatRoomSubmitDiv} style={{ paddingBottom: isFocus ? 0 : "env(safe-area-inset-bottom)" }}>
                        <div className={styles.footerWrapper}>
                            <div className={styles.chatRoomSubmit}>
                                <div className={styles.textSubmitWrapper}>
                                    <div className={styles.textSubmitDiv}>
                                        <div className={styles.textSubmitInput}>
                                            <TextareaAutosize
                                                className={styles.input}
                                                placeholder="채팅이 불가한 방입니다"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal
                        open={open2}
                        onClose={handleClose2}
                    >
                        <Box sx={style}>
                            <div className={styles.modalTitle}>
                                링크 보내기
                            </div>
                            <div className={styles.modalBody}>
                                <TextField value={link} onChange={(e: any) => setLink(e.target.value)} placeholder="링크를 적으세요" fullWidth />
                            </div>
                            <div className={styles.modalFooter}>
                                <div onClick={handleClose2} className={styles.cancelBtn}>
                                    취소
                                </div>
                                <div onClick={(e: any) => { handleSubmit(e, "link") }} className={styles.uploadBtn}>
                                    보내기
                                </div>
                            </div>
                        </Box>
                    </Modal>

                    <IonLoading
                        cssClass='my-custom-class'
                        isOpen={imgLoading}
                        onDidDismiss={() => setImgLoading(false)}
                        message={'잠시만 기다려주세요'}
                    />

                </div>

                <ImageViewer
                    isModalOpen={ionModalOpen}
                    handleClose={ionModalClose}
                    title=""
                    src={ionModalSrc}
                />
            </div>
        </IonApp>
    );
}

export default MobileChatRoomForFeedback;
